import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";

const VKB_LOGO_URL = "https://customer-assets.emergentagent.com/job_ingenieur-agency/artifacts/7oos7e3e_VKBayern_logo.svg.png";
const DQS_LOGO_URL = "https://customer-assets.emergentagent.com/job_3d119e6f-14f2-49d0-b48b-21438dbeafee/artifacts/b0frwk4w_3xp0oxvy_medium_DQS_en.png";
const FEUERSOZIETAET_LOGO_URL = "https://customer-assets.emergentagent.com/job_3d119e6f-14f2-49d0-b48b-21438dbeafee/artifacts/7xpcu6ij_FSB_Logo.png.webp";
const UKV_LOGO_URL = "https://customer-assets.emergentagent.com/job_3d119e6f-14f2-49d0-b48b-21438dbeafee/artifacts/sbfyzkwd_UKV_Logo_sRGB.svg.png";
const OERAG_LOGO_URL = "https://customer-assets.emergentagent.com/job_3d119e6f-14f2-49d0-b48b-21438dbeafee/artifacts/z1vg2anp_Oerag_RS_rot_HKS13_450.jpg";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#0F172A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 gap-4 mb-6 max-w-xs">
              <div className="flex items-center justify-center bg-white rounded-lg p-3">
                <img
                  src={VKB_LOGO_URL}
                  alt="Versicherungskammer Bayern"
                  className="h-20 w-auto"
                />
              </div>
              <div className="flex items-center justify-center bg-white rounded-lg p-3">
                <img
                  src={DQS_LOGO_URL}
                  alt="DQS Zertifiziert"
                  className="h-20 w-auto"
                />
              </div>
            </div>
            <p className="text-slate-400 mb-6 max-w-md">
              Fachagentur für Architekten und Ingenieure. 
              Spezialisiert auf Berufshaftpflicht, Rechtsschutz und Cyber-Absicherung 
              für Planungs- und Baubüros.
            </p>
            <div className="grid grid-cols-3 gap-3 max-w-xs">
              <div className="flex items-center justify-center bg-white rounded-lg p-3 h-20">
                <img
                  src={FEUERSOZIETAET_LOGO_URL}
                  alt="Feuersozietät"
                  className="max-h-14 w-auto object-contain"
                />
              </div>
              <div className="flex items-center justify-center bg-white rounded-lg p-3 h-20">
                <img
                  src={OERAG_LOGO_URL}
                  alt="ÖRAG Rechtsschutz"
                  className="max-h-14 w-auto object-contain"
                />
              </div>
              <div className="flex items-center justify-center bg-white rounded-lg p-3 h-20">
                <img
                  src={UKV_LOGO_URL}
                  alt="UKV"
                  className="max-h-14 w-auto object-contain"
                />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link text-slate-400 hover:text-white" data-testid="footer-link-home">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/leistungen" className="footer-link text-slate-400 hover:text-white" data-testid="footer-link-leistungen">
                  Leistungen
                </Link>
              </li>
              <li>
                <Link to="/vorteile" className="footer-link text-slate-400 hover:text-white" data-testid="footer-link-vorteile">
                  Vorteile
                </Link>
              </li>
              <li>
                <Link to="/ueber-mich" className="footer-link text-slate-400 hover:text-white" data-testid="footer-link-ueber-mich">
                  Über mich
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="footer-link text-slate-400 hover:text-white" data-testid="footer-link-kontakt">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-slate-500 mt-0.5 flex-shrink-0" />
                <div>
                  <a href="tel:+493033937950" className="text-slate-400 hover:text-white transition-colors">
                    +49 30 33937950
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-slate-500 mt-0.5 flex-shrink-0" />
                <div>
                  <a href="mailto:info@mansfeld-versicherungen.de" className="text-slate-400 hover:text-white transition-colors text-sm break-all">
                    info@mansfeld-versicherungen.de
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-slate-500 mt-0.5 flex-shrink-0" />
                <div className="text-slate-400 text-sm">
                  Mo – Fr: 09:00 – 18:00 Uhr
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} Jens-Oliver Mansfeld. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/impressum" className="text-slate-500 hover:text-white text-sm transition-colors" data-testid="footer-link-impressum">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-slate-500 hover:text-white text-sm transition-colors" data-testid="footer-link-datenschutz">
                Datenschutz
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
